import React, { useEffect, Suspense, lazy, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PrivateRoute from './components/routing/PrivateRouter';
import PublicRoute from './components/routing/PublicRouter';

// Redux
import { Provider } from 'react-redux';
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';

// Css
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './index.css';

/*
 * Temporarly import splitted styles here, we need to discuss
 * about files architecture.
 * See : https://fr.reactjs.org/docs/faq-structure.html
 */
import './styles/Titlelight.css';
import './styles/History.css';
import './styles/Formation.css';
import './styles/NotFound.css';
import './styles/BurgerMenu.css';
import './styles/Navbar.css';
import './styles/Chapters.css';
import './styles/Steps.css';
import './styles/Form.css';
import './styles/Courses.css';
import './styles/Messenger.css';
import './styles/Books.css';
import './styles/Loans.css';
import './styles/Alumni.css';
import './styles/Internship.css';
import './styles/Statistics.css';
import './styles/MultiStep.css';
import './styles/Input.css';
import Loading from './components/layout/Loading';
// Not found page
const NotFound = lazy(() => import('./components/public/NotFound'));

const PublicLayout = lazy(() => import('./components/layout/PublicLayout'));

const StudentInfo = lazy(() =>
  import("./components/private/admin/studentCard/view/StudentInfo")
);

const VerificationDocument = lazy(() =>
  import("./payments/VerificationDocument")
);

// S-9 (§12.6) — paiement d'inscription à distance, page PUBLIQUE (jeton).
const PaiementInscription = lazy(() =>
  import("./payments/inscription/PaiementInscription")
);

const EmailConfirmation = lazy(() =>
  import('./components/public/auth/EmailConfirmation')
);

const PrivateLayout = lazy(() => import('./components/layout/PrivateLayout'));

const Document = lazy(() => import('./components/private/admin/Document'));

const SigningList = lazy(() =>
  import('./components/private/admin/composition/SigningList')
);
const PaymentsList = lazy(() =>
  import('./components/private/admin/composition/PaymentsList')
);
const CodeList = lazy(() =>
  import('./components/private/admin/composition/CodeList')
);
const NoSkipperList = lazy(() =>
  import('./components/private/admin/alerts/NoSkipperList')
);
const SkipperStats = lazy(() =>
  import('./components/private/admin/alerts/SkipperStats')
);
const RegistrationNumberForm = lazy(() =>
  import('./components/private/admin/registration/RegistrationNumberForm')
);
const LoginWifi = lazy(() => 
  import('./components/public/authWifi/views/LoginWifi')
);
const RedirectPage = lazy(() => 
  import('./components/public/authWifi/views/RedirectPage')
);


if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const documents = [
  {
    path: '/noskippers/:courseCode/:threshold',
    subDocument: NoSkipperList,
  },
  {
    path: '/skipperstats/:courseCode/:threshold',
    subDocument: SkipperStats,
  },
  {
    path: '/signing/:courseCode/:testroom/:isDistributed',
    subDocument: SigningList,
  },
  { path: '/payment/:courseCode', subDocument: PaymentsList },
  { path: '/codes/:courseCode', subDocument: CodeList },
  {
    path: '/registration/:registrationNumber',
    subDocument: RegistrationNumberForm,
  },
];

const App = () => {
const [checkingToken, setCheckingToken] = useState(true);

  useEffect(() => {
    if (localStorage.token) {
      store.dispatch(loadUser()).finally(() => setCheckingToken(false));
    } else {
      setCheckingToken(false);
    }
  }, []);

  if (checkingToken) {
    return <Loading />;
  }

  return (
    <Provider store={store}>
      <Router>
        <Suspense fallback={<div>Chargement...</div>}>
          <Routes>
            {documents.map(({ path, subDocument }) => (
              <Route
                key={path}
                path={path}
                element={
                  <PrivateRoute>
                    <Document SubDocument={subDocument} />
                  </PrivateRoute>
                }
              />
            ))}

            <Route path='/404' element={<NotFound />} />

            <Route path='/login-internet' element={<LoginWifi />} />

            <Route path='/logged-in' element={<RedirectPage />} />

            <Route
              path='/emailConfirmation/:token'
              element={<EmailConfirmation />}
            />

            {/* S-9 (§12.6) — paiement d'inscription à distance. Route
                PUBLIQUE simple (comme /emailConfirmation) : accessible avec
                le seul jeton, connecté ou non — jamais de redirection. */}
            <Route
              path='/inscription/paiement/:jeton'
              element={<PaiementInscription />}
            />

            <Route
              path='/student-info/:serialNum'
              element={
                <PrivateRoute>
                  <StudentInfo />
                </PrivateRoute>
              }
            />

            {/* I1-F — vérification d'un document par son QR. Même patron
                que la carte : PrivateRoute, donc reprise après login si
                la session du surveillant a expiré. Le second chemin sert
                la saisie manuelle quand le QR est illisible. */}
            <Route
              path='/verification-document/:reference'
              element={
                <PrivateRoute>
                  <VerificationDocument />
                </PrivateRoute>
              }
            />
            <Route
              path='/verification-document'
              element={
                <PrivateRoute>
                  <VerificationDocument />
                </PrivateRoute>
              }
            />

            <Route
              path='/dashboard/*'
              element={
                <PrivateRoute>
                  <PrivateLayout />
                </PrivateRoute>
              }
            />

            <Route
              path='/*'
              element={
                <PublicRoute>
                  <PublicLayout />
                </PublicRoute>
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </Provider>
  );
};

export default App;
